import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import CollapsibleSection from './CollapsibleSection';
import { ListComponent } from '../../components/shared/ListTab';
import { listPath } from '../../utils/constants/insightsPath';
import { formatComplaintsData, formatProductsData } from '../../utils/dataFormatters';
import {
  productColumns,
  complaintColumns,
  complaintOptions,
  getProductActions,
  getComplaintActions
} from './customerConstants';

const CustomerSections = ({
  customer,
  borderColor,
  handleEditProduct,
  handleRaiseComplaint,
  handleViewComplaint,
  handleEditComplaint
}) => {
  const productFilters = useMemo(() => ({ userId: customer.userId }), [customer.userId]);
  const complaintFilters = useMemo(() => ({ userId: customer.userId }), [customer.userId]);

  const productList = useSelector((state) => state.list[listPath.PRODUCT] || { rows: [] });
  const complaintsList = useSelector((state) => state.list[listPath.COMPLAINTS] || { rows: [] });
  const { models } = useSelector((state) => state.models || { models: [] });

  const {
    productCategories,
    productSubcategories,
    serviceRequestCategories,
    serviceRequestSubcategories
  } = useSelector((state) => state.categories);

  const productActions = getProductActions(handleEditProduct, handleRaiseComplaint);
  const complaintActions = getComplaintActions(handleViewComplaint, handleEditComplaint);

  return (
    <>
      {/* Products Section */}
      <CollapsibleSection
        title={`Products Details (${productList?.totalCount || 0})`}
        defaultOpen={false}
        mt={6}
      >
        <ListComponent
          path={listPath.PRODUCT}
          borderColor={borderColor}
          searchPlaceholder="Search by customer..."
          columns={productColumns}
          actions={productActions}
          formatData={(rows) => formatProductsData(
            rows,
            productCategories,
            productSubcategories,
            models,
          )}
          categoryOptions={productCategories}
          subCategoryOptions={productSubcategories}
          userId={customer.userId}
          initialFilters={productFilters}
          hideExport
          hideDateRange
        />
      </CollapsibleSection>

      {/* Complaints Section */}
      <CollapsibleSection
        title={`Complaints Details (${complaintsList?.totalCount || 0})`}
        defaultOpen={false}
        mt={6}
      >
        <ListComponent
          borderColor={borderColor}
          path={listPath.COMPLAINTS}
          searchPlaceholder="Search Complaints..."
          columns={complaintColumns}
          actions={complaintActions}
          formatData={(rows) => formatComplaintsData(
            rows,
            serviceRequestCategories,
            serviceRequestSubcategories,
          )}
          statusOptions={complaintOptions}
          categoryOptions={serviceRequestCategories}
          subCategoryOptions={serviceRequestSubcategories}
          userId={customer.userId}
          initialFilters={complaintFilters}
          hideExport
          hideDateRange
          showSearchBar={true}
        />
      </CollapsibleSection>
    </>
  );
};

export default CustomerSections;
